import { selectCart } from '../../../../customer/redux/cart';
import { selectPosCart } from '../../../../customer/redux/posCart';
import { useCustomerSelector } from '../../../../customer/selectors';
import { getCartLineItems } from '../../../../lib/getCartLineItems';

export const useGetCartLineItems = () => {
  const { cart } = useCustomerSelector(selectCart);
  const { posCart } = useCustomerSelector(selectPosCart);

  const cartLineItems = getCartLineItems({
    cart,
    posCartTotals: posCart?.totals,
    tipAmount: parseFloat(cart.tip_amount),
  });

  return cartLineItems;
};
